/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUpdateVernehmlassungDto } from '../../models/lexplus-update-vernehmlassung-dto';
import { LexplusVernehmlassungDetailDto } from '../../models/lexplus-vernehmlassung-detail-dto';

export interface VernehmlassungControllerUpdateV1$Params {
  id: number;
      body: LexplusUpdateVernehmlassungDto
}

export function vernehmlassungControllerUpdateV1(http: HttpClient, rootUrl: string, params: VernehmlassungControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusVernehmlassungDetailDto>> {
  const rb = new RequestBuilder(rootUrl, vernehmlassungControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusVernehmlassungDetailDto>;
    })
  );
}

vernehmlassungControllerUpdateV1.PATH = '/v1/vernehmlassung/{id}';
